import { Base } from "ui/Scripts/source/framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { DocumentPageData, IDocumentPageData } from "./documentPageData";

export interface IDocumentPage extends IDocumentPageData {
    companyId: string;
    companies: ICompanyMenuItem[];
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
}

export class DocumentPage extends DocumentPageData implements IDocumentPage {
    companyId: string;
    companies: CompanyMenuItem[];
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;

    constructor();
    constructor(obj: IDocumentPage);
    constructor(obj?: any) {
        super(obj);
        this.companyId = obj && obj.companyId || "";
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
    }
}
